const VueLang = {};
const lang = function (vue) {
    this.vueRootInstance = vue;
    this.getCodeMsg = function (code) {
        switch (code) {
            case 0:
                return "操作成功！";
            case 1001:
                return "登录失败，用户名或密码错误！";
            case 1002:
                return "用户没有权限访问租户的数据！";
            case 1003:
                return "新增用户失败，用户名可能已经存在！";
            case 1004:
                return "用户不存在！";
            case 1005:
                return "保存失败，请稍后再试！";
            case 1006:
                return "删除失败，请稍后再试！";
            case 1007:
                return "角色信息不存在！";
            case 1008:
                return "原密码错误！";
            case 1009:
                return "不能对根用户进行操作！";
            case 1010:
                return "角色已经分配到用户，不能删除！";

            case 3001:
                return "实体信息不存在！";
            case 3002:
                return "所属上级不能为空！";
            case 3003:
                return "未能找到选择的上级！";
            case 3004:
                return "请选择所在楼层！";
            case 3005:
                return "您没有权限对该实体进行操作！";
            case 3006:
                return "您没有权限在此上级下增加实体！";
            case 3007:
                return "实体编码已经存在！";
            case 3008:
                return "面积必须大于零！";
            case 3009:
                return "业态已经存在！";
            case 3101:
                return "通道信息不存在！";
            case 3102:
                return "通道在使用中，不能删除！";
            case 3201:
                return "设备信息不存在！";
            case 3202:
                return "设备已经绑定，请勿重复绑定！";

            case 91001:
                return "一个租户只能开通一个应用！";
            case 98001:
                return "数据库创建失败！";
            case 98002:
                return "没有找到数据库！";

            case 99001:
                return "未经授权禁止访问！";
            case 99002:
                return "访问服务器失败！";
            case 99006:
                return "系统已经初始化了租户，不能重复初始化！";
            case 99007:
                return "保存服务器配置失败，服务器错误！";
            case 99008:
                return "已经初始化配置，不能重复配置！";
            case 99009:
                return "未找到租户信息！";
            case 99010:
                return "内容未找到！";
            case 99011:
                return "系统授权已经过期，请联系客服！";
            case 99012:
                return "没有找到要上传的文件！";
            case 99013:
                return "文件格式有误！";
            case 99014:
                return "不能修改根租户的该项配置！";

            default:
                return "未知错误！";
        }
    };
    return this;
};
VueLang.install = function (app) {
    app.mixin({
        beforeCreate() {
            if (!this.$root._rootLanguage) {
                this.$root._rootLanguage = new lang(this.$root);
            }
            if (!this.$lang) {
                this.$lang = this.$root._rootLanguage;
            }
        },
    });
};
export default VueLang;
